// extracted by mini-css-extract-plugin
export var container = "AccordionBar-module--container--b544e";
export var fullWidth = "AccordionBar-module--fullWidth--7de64";
export var icon = "AccordionBar-module--icon--06762";
export var open = "AccordionBar-module--open--990fb";